
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/service",
      function () {
        return require("private-next-pages/service/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/service"])
      });
    }
  